<div class="w-full [perspective:1000px] group/card">
  <div class="relative w-full transition-transform duration-500 [transform-style:preserve-3d]"
       [style.transform]="isFlipped() ? 'rotateY(180deg)' : 'rotateY(0deg)'">

    <div class="w-full [backface-visibility:hidden] border rounded-xl shadow-md overflow-hidden flex flex-col transition-all duration-300"
         [ngClass]="{
           'bg-success/10 border-success/30': action.executionState?.status === 'success',
           'bg-danger/10 border-danger/30': action.executionState?.status === 'error',
           'bg-component-inner border-secondary-border': action.executionState?.status !== 'success' && action.executionState?.status !== 'error'
         }">

      <div class="px-2 py-3 border-b relative flex items-center justify-between"
           [ngClass]="{
             'bg-success/5 border-success/20': action.executionState?.status === 'success',
             'bg-danger/5 border-danger/20': action.executionState?.status === 'error',
             'bg-alt-background border-secondary-border': action.executionState?.status !== 'success' && action.executionState?.status !== 'error'
           }">
        <div class="flex items-center gap-0 w-full pr-24">
          <div class="w-[32px] flex items-center justify-start shrink-0">
            @if (getOperationIconAndColor(action.operation, isDiscarded, action).needsWhiteBackdrop) {
            <div
                 class="absolute w-[28px] h-[28px] left-[14px] flex items-center justify-center z-0 pointer-events-none">
              <div class="w-[14px] h-[14px] bg-white rounded-sm"></div>
            </div>
            }
            <i
               [class]="getOperationIconAndColor(action.operation, isDiscarded, action).icon + ' ' + getOperationIconAndColor(action.operation, isDiscarded, action).colorClass + ' text-[18px] z-10 relative'"></i>
          </div>
          <span class="font-semibold text-sm text-primary-text transition-all flex-1 min-w-0 pl-1"
                [ngClass]="{'line-through text-secondary-text': isDiscarded}">
            {{ action.description }}
          </span>
        </div>

        <div class="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-2">
          @if (action.executionState?.status === 'success' || action.executionState?.status === 'error') {
          <button nz-button
                  nzType="default"
                  nzSize="small"
                  (click)="toggleFlip($event)"
                  class="opacity-0 group-hover/card:opacity-100 transition-opacity !rounded-md text-[11px] flex items-center gap-1.5 bg-component-inner shadow-sm border-secondary-border text-secondary-text hover:text-primary focus:outline-none">
            <i class="fa-regular fa-brackets-curly"></i>
            <span i18n="@@endpointActionCard.request">&nbsp;Request</span>
          </button>
          }
          <span
                class="bg-component-inner text-secondary-text border border-secondary-border px-1.5 py-0.5 rounded text-[11px] font-mono font-bold shadow-sm">
            {{ index }}
          </span>
        </div>
      </div>

      @if (!isDiscarded && !isCollapsed) {
      @if (action.executionState?.status !== 'success' && action.executionState?.status !== 'error') {
      @if (action.payload.http?.body || action.payload.http?.params || action.payload.input) {
      <div
           class="p-4 bg-alt-bold-background border-b border-secondary-border custom-scrollbar overflow-x-auto max-h-[400px]">
        @for(item of normalizePayloadToArray(cleansedData()); let index = $index; track index) {
        <div class="p-3 bg-component-inner rounded-lg shadow-sm border border-secondary-border mb-3 last:mb-0">
          @if(getExtractedMetaTitle(index)) {
          <h4 class="text-sm font-semibold text-primary-text">{{ getExtractedMetaTitle(index) }}</h4>
          <hr class="my-2 border-secondary-border" />
          }
          <rapider-json-viewer [data]="item"
                               [maxLineToDisplay]="20"
                               class="w-full h-auto"></rapider-json-viewer>
        </div>
        }
      </div>
      }
      }

      @if (action.executionState?.status === 'success' || action.executionState?.status === 'error') {
      <div class="p-4 border-b"
           [ngClass]="action.executionState?.status === 'success' ? 'border-success/20' : 'border-danger/20'">
        @if (action.executionState?.response) {
        <div class="bg-component-inner rounded border border-secondary-border p-2">
          <rapider-json-viewer [data]="action.executionState?.response"
                               [maxLineToDisplay]="10"></rapider-json-viewer>
        </div>
        }

        @if (action.executionState?.error) {
        <div class="text-sm mt-2 text-danger font-medium break-words bg-white/50 p-2 rounded border border-red-100">
          {{ action.executionState?.error }}
        </div>

        @if (isDevAgentRequiredError(action.executionState?.error)) {
        <div class="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg flex flex-col gap-3 shadow-sm">
          <div class="flex items-start gap-3">
            <div class="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center shrink-0">
              <i class="fa-solid fa-server text-red-600 text-sm"></i>
            </div>
            <div>
              <h5 class="text-red-800 font-bold text-sm m-0 pb-1">{{ config.texts.devAgentRequiredTitle }}</h5>
              <p class="text-red-700/90 text-xs leading-relaxed m-0">
                {{ config.texts.devAgentRequiredMessage }}
              </p>
            </div>
          </div>

          <div class="flex justify-end mt-2 pt-3 border-t border-red-200/60">
            <button nz-button
                    nzType="primary"
                    nzDanger
                    (click)="runDevAgent()"
                    class="flex items-center gap-2 shadow hover:shadow-md transition-all border-none bg-red-600 hover:bg-red-700 rounded-md !text-white h-9 px-4">
              <i class="fa-solid fa-robot-astromech fa-bounce"></i>
              <span class="font-semibold">{{ config.texts.runDevAgentBtn }}</span>
            </button>
          </div>
        </div>
        }
        }
      </div>
      }
      }

      @if (action.executionState?.status === 'error' && !isDevAgentRequiredError(action.executionState?.error)) {
      <div class="mt-4 pt-3 border-t border-danger/20 flex justify-end px-4 pb-4">
        <button nz-button
                nzType="primary"
                nzDanger
                (click)="runDevAgent()"
                class="flex items-center gap-2 shadow-sm hover:shadow-md transition-all">
          <i class="fa-solid fa-robot-astromech fa-bounce"></i>
          <span>{{ config.texts.runDevAgentBtn }}</span>
        </button>
      </div>
      }

      <div class="px-4 py-3 flex items-center justify-between gap-3 relative transition-colors cursor-pointer hover:bg-black/5 dark:hover:bg-white/5"
           role="button"
           tabindex="0"
           [attr.aria-expanded]="!isCollapsed"
           [ngClass]="{
             'bg-success/5': action.executionState?.status === 'success',
             'bg-danger/5': action.executionState?.status === 'error',
             'bg-alt-background': action.executionState?.status !== 'success' && action.executionState?.status !== 'error'
           }"
           (click)="toggleCollapse.emit()"
           (keydown.enter)="toggleCollapse.emit()"
           (keydown.space)="toggleCollapse.emit()">

        <div class="mr-auto pl-2 flex items-center gap-3">
          @if (entityName) {
          <nz-tag [routerLink]="['/navigate-to-project-model-with-name', entityName]"
                  (click)="$event.stopPropagation()"
                  nz-tooltip
                  nzTooltipTitle="Open Table Reference"
                  class="cursor-pointer hover:bg-hover-default transition-colors !m-0 !flex !items-center !gap-1.5 border-secondary-border bg-component-inner shadow-sm rounded-md py-1.5 px-3">
            <i class="fas fa-table text-primary text-xs"></i>
            <span class="font-bold text-xs tracking-wide text-primary-text">{{ entityName }}</span>
          </nz-tag>
          }

          @if (action.executionState?.status === 'success' && !isWorkflowTrigger(action)) {
          <button nz-button
                  nzType="default"
                  nzSize="small"
                  class="opacity-0 group-hover/card:opacity-100 border-secondary-border text-secondary-text hover:text-primary hover:border-primary flex items-center gap-2 rounded-md transition-opacity duration-200 focus:outline-none"
                  (click)="onShowInCanvas(); $event.stopPropagation();">
            <i class="fa-regular fa-browser"></i> <span i18n="@@endpointActionCard.showInCanvas">Show in Canvas</span>
          </button>
          }
        </div>

        <div class="flex items-center gap-3 ml-auto"
             (keydown)="$event.stopPropagation()"
             role="region">
          @if (isDiscarded) {
          <span class="text-sm text-secondary-text italic mr-auto"
                i18n="@@aiChat.actionDiscardedMsg">Action discarded.</span>
          <button nz-button
                  nzType="default"
                  class="border-secondary-border text-secondary-text hover:text-primary hover:border-primary focus:outline-none flex items-center gap-2 rounded-md font-medium px-4"
                  (click)="undoDiscard.emit(action); $event.stopPropagation();">
            <i class="fas fa-rotate-left"></i>
            <span i18n="@@aiChat.undoAction">Undo</span>
          </button>
          } @else {

          @if (action.executionState?.status === 'loading') {
          <div class="flex items-center gap-2 px-4 py-1.5">
            <i class="fas fa-circle-notch fa-spin text-primary"></i>
            <span class="text-sm font-medium text-primary">Executing...</span>
          </div>
          } @else if (action.executionState?.status === 'success' || action.executionState?.status === 'error') {
          <span class="text-sm italic font-medium transition-opacity duration-200 group-hover/card:opacity-0"
                [ngClass]="action.executionState?.status === 'success' ? 'text-success' : 'text-danger'">
            <i class="fas"
               [ngClass]="action.executionState?.status === 'success' ? 'fa-check' : 'fa-times'"></i>
            <span i18n="@@aiChat.actionExecutedMsg">
              {{ action.executionState?.status === 'success' ? 'Executed successfully' : 'Error' }}
            </span>
          </span>
          } @else {
          <button nz-button
                  nzType="default"
                  class="border-secondary-border text-secondary-text hover:text-danger hover:border-danger focus:outline-none flex items-center gap-2 rounded-[6px] font-medium py-1 px-3 text-[13px] transition-colors"
                  (click)="discard.emit(action); $event.stopPropagation();">
            <i class="fas fa-times text-xs"></i>
            <span>{{ getActionButtonLabels(action, message.actionsUIConfig).secondary }}</span>
          </button>

          @if (!hideExecuteButton) {
          <button nz-button
                  (click)="execute.emit(action); $event.stopPropagation();"
                  class="bg-[#27272A] hover:bg-[#3F3F46] dark:bg-[#D4D4D8] dark:hover:bg-[#E4E4E7] text-[#FAFAFA] dark:text-[#18181B] border border-black/10 dark:border-white/10 shadow-xs focus:outline-none flex items-center gap-2 rounded-[6px] font-medium py-1 px-3.5 text-[13px] transition-colors cursor-pointer">
            <i class="fas fa-check text-xs"></i>
            <span>{{ getActionButtonLabels(action, message.actionsUIConfig).primary }}</span>
          </button>
          }
          }
          }

          <button nz-button
                  nzType="text"
                  class="border-none text-secondary-text hover:text-primary focus:outline-none flex items-center justify-center p-0 w-8 h-8 rounded-full ml-1"
                  (click)="toggleCollapse.emit(); $event.stopPropagation();">
            <i class="fas text-lg transition-transform duration-200"
               [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
          </button>
        </div>
      </div>
    </div>

    <div
         class="absolute top-0 left-0 w-full h-full [backface-visibility:hidden] [transform:rotateY(180deg)] bg-component-inner border border-primary-border rounded-xl shadow-md flex flex-col overflow-hidden z-10">
      <div
           class="px-4 py-3 border-b border-secondary-border flex justify-between items-center bg-alt-background shrink-0">
        <div class="flex items-center gap-2">
          @if (isServerAction(action)) {
          <span class="px-2 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wider border border-[#e4e4e7] dark:border-[#3f3f46] bg-[#f4f4f5] dark:bg-[#27272a] text-[#52525b] dark:text-[#d4d4d8]">
            SERVER ACTION
          </span>
          <span class="font-mono text-xs text-primary-text">{{ action.title || action.description }}</span>
          } @else {
          <span class="px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider border"
                [ngClass]="getHttpMethodColorClass(action.payload.http?.method)">
            {{ action.payload.http?.method }}
          </span>
          <span class="font-mono text-xs text-primary-text">{{ action.payload.http?.path }}</span>
          }
        </div>
        <button (click)="toggleFlip($event)"
                title="Back to Response"
                class="text-primary hover:text-secondary-text transition-colors focus:outline-none w-8 h-8 flex items-center justify-center rounded hover:bg-hover-default">
          <i class="fa-solid fa-arrow-rotate-left"></i>
        </button>
      </div>
      <div class="p-4 flex-1 overflow-y-auto custom-scrollbar bg-component-inner">
        <div class="text-xs font-bold text-secondary-text uppercase tracking-wider mb-2">
          @if (isServerAction(action)) {
          <span i18n="@@aiChat.actionParameters">Action Parameters</span>
          } @else {
          <span i18n="@@aiChat.requestPayload">Request Payload</span>
          }
        </div>
        @if (action.payload.http?.body || action.payload.http?.params || action.payload.input) {
        @for(item of normalizePayloadToArray(cleansedData()); let idx = $index; track idx) {
        <div class="p-3 bg-alt-background rounded-lg shadow-sm border border-secondary-border mb-3 last:mb-0">
          @if(getExtractedMetaTitle(idx)) {
          <h4 class="text-sm font-semibold text-primary-text">{{ getExtractedMetaTitle(idx) }}</h4>
          <hr class="my-2 border-secondary-border" />
          }
          <rapider-json-viewer [data]="item"
                               [maxLineToDisplay]="20"
                               class="w-full h-auto"></rapider-json-viewer>
        </div>
        }
        } @else {
        <div class="text-sm text-secondary-text italic"
             i18n="@@aiChat.noRequestPayload">No parameters payload.</div>
        }
      </div>
    </div>

  </div>
</div>